export enum triResultatRechercheEnum {
	disponibilite = 'disponibilite',
	nouveaute = 'nouveaute',
	prixCroissant = 'prixCroissant',
	prixDecroissant = 'prixDecroissant',
	offreSpeciale = 'offreSpeciale'
}